import { render, staticRenderFns } from "./TestAnswer.vue?vue&type=template&id=7a1b311c&scoped=true"
import script from "./TestAnswer.vue?vue&type=script&lang=js"
export * from "./TestAnswer.vue?vue&type=script&lang=js"
import style0 from "./TestAnswer.vue?vue&type=style&index=0&id=7a1b311c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1b311c",
  null
  
)

export default component.exports